import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=1406e516&scoped=true"
import script from "./ResultsPage.vue?vue&type=script&lang=js"
export * from "./ResultsPage.vue?vue&type=script&lang=js"
import style0 from "./ResultsPage.vue?vue&type=style&index=0&id=1406e516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406e516",
  null
  
)

export default component.exports